import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Typography, Container, Alert } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { useT, useLang } from './i18n/langContext';
import cookieIt from './legal/cookie.it';
import cookieEn from './legal/cookie.en';

const BODIES = { it: cookieIt, en: cookieEn };
const SECTION_KEYS = [
  'titolare', 'cosaSono', 'strumentiUsati', 'baseGiuridica',
  'gestirePreferenze', 'trasferimenti', 'diritti', 'aggiornamenti',
];

// Same layout/Section pattern as PrivacyPolicy.jsx (not shared via import to
// keep each page's blast radius independent).
function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ fontFamily: theme.home.display, fontWeight: 700, mb: 1.5 }}>{title}</Typography>
      <Typography component="div" sx={{ color: theme.home.inkMuted, lineHeight: 1.7 }}>{children}</Typography>
    </Box>
  );
}

function CookiePolicy() {
  const t = useT();
  const { lang } = useLang();
  const body = BODIES[lang] || BODIES.it;
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: theme.home.paper, color: theme.home.ink, minHeight: '100vh' }}>
        <Navbar />
        <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
          <Typography variant="h3" sx={{ fontFamily: theme.home.display, fontWeight: 800, mb: 1 }}>
            {t('cookies.page.title')}
          </Typography>
          <Typography sx={{ color: theme.home.inkMuted, fontStyle: 'italic', mb: 2 }}>
            {t('cookies.page.preamble')}
          </Typography>
          <Typography sx={{ color: theme.home.inkMuted, mb: 5 }}>{t('cookies.page.lastUpdated')}</Typography>

          {lang === 'en' && (
            <Alert severity="warning" sx={{ mb: 4 }}>{t('legal.draftNotice')}</Alert>
          )}

          {SECTION_KEYS.map((key) => (
            <Section key={key} title={t(`cookies.page.sections.${key}`)}>{body[key]}</Section>
          ))}
        </Container>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default CookiePolicy;
